import { useTranslation } from 'react-i18next'
import { DefaultTourControl } from '@/features/tenant-destination/default-tour-control'

interface TenantFeatureAvailabilityProps {
  tenantId: string
}

export function TenantFeatureAvailability({ tenantId }: TenantFeatureAvailabilityProps) {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-amber-100 bg-amber-50 px-3 py-2 text-sm text-amber-700">
        {t('tenant.featureAvailability.description', {
          defaultValue: 'Control which product features are enabled for this tenant.',
        })}
      </div>

      <DefaultTourControl tenantId={tenantId} />
    </div>
  )
}
